import React from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'

export default function WhatHappenNext() {
    const paperStyle = {
        borderRadius: '12px',
        padding: '16px',
        backgroundColor: 'var(--neutral-50)',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    }
    return (
        <div style={paperStyle}>
            <div
                style={{
                    fontWeight: 600,
                    fontStyle: 'Semi Bold',
                    fontSize: 14,
                    leadingTrim: 'NONE',
                    lineHeight: '22px',
                    letterSpacing: '-0.13px'
                }}
            >
                What happens next?
            </div>
            <Row>Your contacts will be shared between Capsule and Transpond</Row>
            <Row>Your Capsule Segments and Tags are available to use in Transpond</Row>
            <Row>Any new contacts in Capsule will be automatically available in Transpond</Row>
            <Row>Only contacts with email addresses will be available in Transpond</Row>
        </div>
    )
}

function Row({ children }) {
    return (
        <div className='quickFlex forceFlex' style={{ gap: 8, alignItems: 'center' }}>
            <Icons icon='tickCircleGreen' color='var(--cyan-500)' style={{ height: 16, width: 16 }} />
            <div
                style={{
                    fontWeight: 400,
                    fontStyle: 'Regular',
                    fontSize: 14,
                    leadingTrim: 'NONE',
                    lineHeight: '22px',
                    letterSpacing: '-0.13px'
                }}
            >
                {children}
            </div>
        </div>
    )
}
